$(document).ready(function(){
  $(document).on('click',".t4s-btn-coupon",function(){
    let text = $(this).data("coupon");
    navigator.clipboard.writeText(text);
    $(this).find(".tooltiptext").text( T4Sstrings.copied_tooltipText + ": " + text);

  })
  $(document).on('mouseleave',".t4s-btn-coupon",function(){
    $(this).find(".tooltiptext").text(T4Sstrings.copy_tooltipText);
   
  })
});

(function () {
  var selectors = ['#shopify-pc__banner', '[data-kl-scroll-locking-modal="true"]'];
  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }
  function syncOverlayState() {
    if (!document.body) return;
    var mobile = window.matchMedia('(max-width: 767px)').matches;
    var open = mobile && selectors.some(function (selector) {
      return Array.prototype.some.call(document.querySelectorAll(selector), isVisible);
    });
    document.body.classList.toggle('m2u-overlay-open', open);
  }
  function ensureEstimateLabels() {
    Array.prototype.forEach.call(document.querySelectorAll('#t4s-mini_cart [data-cart-tool_action][data-id="rates"]'), function (button) {
      if (!button.querySelector('.m2u-cart-tool-label')) {
        var label = document.createElement('span');
        label.className = 'm2u-cart-tool-label';
        label.textContent = button.getAttribute('title') || 'Estimate shipping';
        button.appendChild(label);
      }
      button.setAttribute('role', 'button');
      button.setAttribute('tabindex', '0');
    });
  }
  function start() {
    syncOverlayState();
    ensureEstimateLabels();
    new MutationObserver(function () {
      syncOverlayState();
      ensureEstimateLabels();
    }).observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
    window.addEventListener('resize', syncOverlayState, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();


(function () {
  if (document.getElementById('m2u-r6-styles')) return;
  var style = document.createElement('style');
  style.id = 'm2u-r6-styles';
  style.textContent = "/* Melatonin2U mobile purchase flow */\n.t4s-swatch__option:has(.t4s-swatch__list > .t4s-swatch__item:only-child) .t4s-swatch__list { display: none !important; }\n.t4s-swatch__option:has(.t4s-swatch__list > .t4s-swatch__item:only-child) .t4s-swatch__title { margin-bottom: 6px !important; }\n.t4s-swatch__option:has(.t4s-swatch__list > .t4s-swatch__item:only-child) .t4s-swatch__current { font-weight: 600; color: #11104f; }\n#t4s-mini_cart .mini_cart_tool_btn.is--rates { width: auto; min-width: 124px; padding: 0 12px; gap: 7px; display: inline-flex; align-items: center; justify-content: center; }\n#t4s-mini_cart .mini_cart_tool_btn.is--rates svg { flex: 0 0 22px; }\n#t4s-mini_cart .m2u-cart-tool-label { display: inline; font-size: 12px; font-weight: 600; white-space: nowrap; }\n\n@media (max-width: 767px) {\n  shopify-chat { display: none !important; }\n  .whatsapp-floating-button { right: 12px !important; bottom: calc(82px + env(safe-area-inset-bottom)) !important; }\n  body.m2u-overlay-open .whatsapp-floating-button,\n  body.m2u-overlay-open .t4s-sticky-atc { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }\n  [data-kl-scroll-locking-modal=\"true\"] button[aria-label*=\"close\" i] { min-width: 44px !important; min-height: 44px !important; }\n  #t4s-mini_cart .mini_cart_tool_btn.is--rates { min-width: 142px; }\n}\n";
  document.head.appendChild(style);
})();

(function () {
  var announcer;
  var observer;

  function ensureAnnouncer() {
    if (announcer) return announcer;
    announcer = document.getElementById('m2u-status');
    if (!announcer) {
      announcer = document.createElement('div');
      announcer.id = 'm2u-status';
      announcer.className = 'm2u-visually-hidden';
      announcer.setAttribute('role', 'status');
      announcer.setAttribute('aria-live', 'polite');
      announcer.setAttribute('aria-atomic', 'true');
      document.body.appendChild(announcer);
    }
    return announcer;
  }

  function announce(message) {
    var live = ensureAnnouncer();
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 20);
  }

  function setLabel(selector, label) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (element) {
      if (!element.getAttribute('aria-label')) element.setAttribute('aria-label', label);
    });
  }

  function syncMenuTriggerState() {
    var trigger = document.querySelector('a.t4s-push-menu-btn[data-menu-drawer]');
    if (!trigger) return;
    var drawer = document.querySelector('#t4s-menu-drawer, .t4s-menu-drawer');
    var open = Boolean(drawer && drawer.getAttribute('aria-hidden') === 'false');
    if (drawer && !drawer.id) drawer.id = 't4s-menu-drawer';
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-controls', drawer ? drawer.id : 't4s-menu-drawer');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    trigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  function labelControls() {
    syncMenuTriggerState();
    setLabel('header a[href="/search"], header a[href$="/search"]', 'Search');
    setLabel('header a[href="/account"], header a[href$="/account"]', 'Account');
    setLabel('header a.t4s-d-inline-block[href="/"]', 'Melatonin2U home');
    setLabel('button[data-decrease-qty]', 'Decrease quantity');
    setLabel('button[data-increase-qty]', 'Increase quantity');
    setLabel('button.t4s-mini-search__submit', 'Submit search');

    Array.prototype.forEach.call(document.querySelectorAll('input[name="quantity"]'), function (input) {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Quantity');
      input.setAttribute('inputmode', 'numeric');
    });

    Array.prototype.forEach.call(document.querySelectorAll('#t4s-mini_cart input[name="zip"], #t4s-mini_cart input[name="address[zip]"]'), function (input) {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('autocomplete', 'postal-code');
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Postcode');
    });

    var grid = document.querySelector('[data-contentlm-replace]');
    var footer = document.querySelector('[data-wrap-lm]');
    var loadMore = document.querySelector('[data-load-more]');
    if (grid) {
      if (!grid.id) grid.id = 'm2u-product-results';
      grid.setAttribute('aria-busy', 'false');
    }
    if (footer) {
      footer.setAttribute('role', 'status');
      footer.setAttribute('aria-live', 'polite');
      footer.setAttribute('aria-atomic', 'true');
    }
    if (loadMore && grid) loadMore.setAttribute('aria-controls', grid.id);

    Array.prototype.forEach.call(document.querySelectorAll('#menu-mb__ul li.t4s-menu-item-has-children > a'), function (link, index) {
      var submenu = link.parentElement && link.parentElement.querySelector(':scope > ul');
      if (!submenu) return;
      if (!submenu.id) submenu.id = 'm2u-mobile-submenu-' + index;
      link.setAttribute('aria-controls', submenu.id);
      link.setAttribute('aria-haspopup', 'true');
      var open = window.getComputedStyle(submenu).display !== 'none' && submenu.getBoundingClientRect().height > 0;
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function improveEmptyCart() {
    Array.prototype.forEach.call(document.querySelectorAll('.t4s-mini_cart__emty'), function (empty) {
      if (empty.querySelector('.m2u-empty-actions')) return;
      var heading = empty.querySelector('.t4s-cart_page_heading');
      var copy = empty.querySelector('.t4s-cart_page_txt');
      if (heading) heading.textContent = 'Your cart is ready for a fresh start';
      if (copy) copy.textContent = 'Browse available melatonin products or compare formats and labelled strengths before choosing.';
      var actions = document.createElement('div');
      actions.className = 'm2u-empty-actions';
      actions.innerHTML = '<a class="m2u-primary-action" href="/collections/melatonin?filter.v.availability=1">Shop in-stock melatonin</a><a class="m2u-secondary-action" href="/collections/melatonin#compare-options">Compare options</a>';
      empty.appendChild(actions);
    });
  }

  function waitForCartDrawer() {
    return new Promise(function (resolve, reject) {
      var deadline = Date.now() + 8000;
      function check() {
        var cart = window.T4SThemeSP && window.T4SThemeSP.Cart;
        var drawer = document.getElementById('t4s-mini_cart');
        if (cart && typeof cart.renderContents === 'function' && drawer &&
            drawer.querySelector('[data-cart-items]') && drawer.querySelector('[data-cart-prices]')) {
          resolve(cart);
        } else if (Date.now() >= deadline) {
          reject(new Error('Cart drawer is unavailable'));
        } else {
          window.setTimeout(check, 50);
        }
      }
      check();
    });
  }

  function validCartSections(sections) {
    return sections && typeof sections.cart_data === 'string' &&
      sections.cart_data.indexOf('[t4s_split1]') !== -1 &&
      sections.cart_data.indexOf('[t4s_split2]') !== -1 &&
      typeof sections.mini_cart === 'string' &&
      sections.mini_cart.indexOf('data-cart-items') !== -1 &&
      sections.mini_cart.indexOf('data-cart-prices') !== -1;
  }

  function cartSections(response) {
    if (validCartSections(response.sections)) return Promise.resolve(response.sections);
    var url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart_data,mini_cart');
    return window.fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (result) {
        if (!result.ok) throw new Error('Unable to refresh cart');
        return result.json();
      })
      .then(function (sections) {
        if (!validCartSections(sections)) throw new Error('Cart sections are unavailable');
        return sections;
      });
  }

  function addVariant(variantId, button, productTitle) {
    var added = false;
    var cartRenderer;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    button.disabled = true;
    button.textContent = 'Adding…';
    waitForCartDrawer().then(function (cart) {
      cartRenderer = cart;
      return window.fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: ['cart_data', 'mini_cart'],
          sections_url: window.location.pathname
        })
      });
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add product');
      added = true;
      return response.json();
    }).then(cartSections).then(function (sections) {
      cartRenderer.renderContents(sections, true);
      button.textContent = 'Added — view cart';
      button.setAttribute('aria-label', 'View cart with ' + productTitle);
      button.disabled = false;
      button.dataset.added = 'true';
      announce(productTitle + ' added to cart');
    }).catch(function () {
      button.disabled = false;
      if (added) {
        button.textContent = 'Added — view cart';
        button.dataset.added = 'true';
        announce(productTitle + ' added. Opening your cart.');
        window.location.href = root + 'cart';
        return;
      }
      button.textContent = 'View product';
      announce('Please continue on the product page');
      if (button.dataset.productUrl) window.location.href = button.dataset.productUrl;
    });
  }

  function quickAdd(card, button, productTitle) {
    var handle = button.dataset.handle;
    if (!handle) {
      window.location.href = button.dataset.productUrl;
      return;
    }
    button.disabled = true;
    button.textContent = 'Checking…';
    window.fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load product');
        return response.json();
      })
      .then(function (product) {
        var available = product.variants.filter(function (variant) { return variant.available; });
        if (available.length === 1) {
          addVariant(available[0].id, button, productTitle);
          return;
        }
        button.disabled = false;
        button.textContent = 'Choose options';
        announce('Choose product options');
        var quickShop = card.querySelector('[data-action-quickshop]');
        if (quickShop) quickShop.click();
        else window.location.href = button.dataset.productUrl;
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'View product';
        window.location.href = button.dataset.productUrl;
      });
  }

  function enhanceProductCards() {
    Array.prototype.forEach.call(document.querySelectorAll('.t4s-product[data-product-options]'), function (card) {
      if (card.querySelector('.m2u-quick-add')) return;
      var raw = card.getAttribute('data-product-options');
      var data;
      try { data = JSON.parse(raw); } catch (error) { return; }
      if (!data.available || !data.VariantFirstID) return;
      var info = card.querySelector('.t4s-product-info__inner') || card.querySelector('.t4s-product-info');
      var titleLink = card.querySelector('.t4s-product-title a');
      if (!info || !titleLink) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'm2u-quick-add';
      button.textContent = 'Quick add';
      button.dataset.variantId = data.VariantFirstID;
      button.dataset.handle = data.handle || '';
      button.dataset.productUrl = titleLink.getAttribute('href') || ('/products/' + data.handle);
      button.setAttribute('aria-label', 'Add ' + titleLink.textContent.trim() + ' to cart');
      button.addEventListener('click', function () {
        if (button.dataset.added === 'true') {
          window.location.href = '/cart';
          return;
        }
        quickAdd(card, button, titleLink.textContent.trim());
      });
      var actions = document.createElement('div');
      actions.className = 'm2u-card-actions';
      actions.appendChild(button);
      info.appendChild(actions);
    });
  }

  function announceQuantity(button) {
    var wrapper = button.closest('.t4s-quantity-wrapper');
    var input = wrapper && wrapper.querySelector('input[name="quantity"], input[type="number"]');
    if (!input) return;
    window.setTimeout(function () { announce('Quantity ' + input.value); }, 60);
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var quantityButton = event.target.closest('button[data-decrease-qty], button[data-increase-qty]');
      if (quantityButton) announceQuantity(quantityButton);
      var loadMore = event.target.closest('[data-load-more]');
      if (loadMore) {
        var grid = document.querySelector('[data-contentlm-replace]');
        if (grid) grid.setAttribute('aria-busy', 'true');
        announce('Loading more products');
      }
      var disclosure = event.target.closest('#menu-mb__ul li.t4s-menu-item-has-children > a');
      if (disclosure) window.setTimeout(labelControls, 80);
      var menuTrigger = event.target.closest('a.t4s-push-menu-btn[data-menu-drawer]');
      if (menuTrigger) window.setTimeout(labelControls, 120);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var drawer = document.querySelector('#t4s-menu-drawer, .t4s-menu-drawer');
      if (!drawer) return;
      var close = drawer.querySelector('[data-drawer-close], button[aria-label*="Close" i]');
      if (close) {
        close.click();
        var trigger = document.querySelector('a.t4s-push-menu-btn[data-menu-drawer]');
        if (trigger) trigger.focus();
        window.setTimeout(labelControls, 120);
      }
    });
  }

  function enhance() {
    labelControls();
    improveEmptyCart();
    enhanceProductCards();
  }

  function start() {
    ensureAnnouncer();
    enhance();
    bindEvents();
    observer = new MutationObserver(function () {
      window.requestAnimationFrame(enhance);
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

(function () {
  if (document.getElementById('m2u-r10-styles')) return;
  var style = document.createElement('style');
  style.id = 'm2u-r10-styles';
  style.textContent = [
    '.m2u-visually-hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important}',
    '.m2u-quick-add,.m2u-primary-action,.m2u-secondary-action{display:inline-flex;align-items:center;justify-content:center;min-height:44px;border-radius:6px;font-weight:700;text-align:center;text-decoration:none;transition:opacity .2s ease,transform .2s ease}',
    '.m2u-quick-add{width:100%;margin-top:12px;padding:10px 14px;border:1px solid #080071;background:#080071;color:#fff;cursor:pointer;font:inherit;font-weight:700}',
    '#m2u-product-results .t4s-product>.t4s-product-wrapper{display:flex;flex-direction:column;width:100%;height:100%}',
    '#m2u-product-results .t4s-product-inner{flex-shrink:0}',
    '#m2u-product-results .t4s-product-info,#m2u-product-results .t4s-product-info__inner{display:flex;flex-direction:column;flex:1;min-width:0}',
    '.m2u-card-actions{margin-top:auto;padding-top:12px;width:100%}',
    '.m2u-card-actions .m2u-quick-add{margin-top:0}',
    '.m2u-quick-add:hover,.m2u-primary-action:hover{opacity:.9;transform:translateY(-1px)}',
    '.m2u-quick-add:focus-visible,.m2u-primary-action:focus-visible,.m2u-secondary-action:focus-visible{outline:3px solid #f5c842;outline-offset:3px}',
    '.m2u-quick-add:disabled{opacity:.65;cursor:wait}',
    '.m2u-empty-actions{display:flex;flex-wrap:wrap;gap:12px;justify-content:center;margin-top:22px}',
    '.m2u-primary-action,.m2u-secondary-action{padding:12px 20px}',
    '.m2u-primary-action{background:#080071;color:#fff}',
    '.m2u-secondary-action{border:2px solid #080071;color:#080071;background:#fff}',
    '.m2u-content{max-width:980px;margin:0 auto;color:#17172f}',
    '.m2u-content__lead{font-size:1.1rem;line-height:1.65;max-width:760px}',
    '.m2u-summary-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:16px;margin:28px 0}',
    '.m2u-summary-card{border:1px solid #d8dceb;border-radius:12px;padding:22px;background:#fff}',
    '.m2u-summary-card h2,.m2u-summary-card h3{margin:0 0 8px;color:#080071}',
    '.m2u-summary-card p{margin:0 0 8px;line-height:1.55}',
    '.m2u-summary-card a{font-weight:700}',
    '.m2u-dose-table{width:100%;border-collapse:collapse;margin:24px 0}',
    '.m2u-dose-table th,.m2u-dose-table td{padding:14px;border:1px solid #d8dceb;text-align:left;vertical-align:top}',
    '.m2u-dose-table th{background:#edf7fb;color:#080071}',
    '.m2u-note{border-left:4px solid #f5c842;background:#fff9df;padding:16px 18px;margin:24px 0}',
    '.m2u-help-actions{display:flex;flex-wrap:wrap;gap:12px;margin:24px 0}',
    '@media(max-width:767px){.m2u-summary-grid{grid-template-columns:1fr}.m2u-dose-table{display:block;overflow-x:auto;white-space:normal}.m2u-content__lead{font-size:1rem}.m2u-quick-add{min-height:46px}.m2u-empty-actions{flex-direction:column}.m2u-empty-actions a{width:100%}button[data-decrease-qty],button[data-increase-qty],[data-load-more]{min-width:44px!important;min-height:44px!important}}'
  ].join('');
  document.head.appendChild(style);
})();

(function () {
  var mobile = window.matchMedia('(max-width: 767px)');
  var pending = false;

  function promoteUnavailableStatus() {
    var media = document.querySelector('#MainContent .t4s-product__media-wrapper');
    var recovery = document.querySelector('#MainContent .m2u-product-recovery');
    if (!media || !recovery || document.querySelector('.m2u-mobile-availability')) return;
    var title = recovery.querySelector('.m2u-product-recovery__title');
    var link = recovery.querySelector('.m2u-product-recovery__links a:last-child');
    if (!title || !link) return;
    var notice = document.createElement('aside');
    notice.className = 'm2u-mobile-availability t4s-col-12';
    notice.setAttribute('aria-label', recovery.getAttribute('aria-label') || title.textContent);
    var heading = document.createElement('p');
    heading.textContent = title.textContent;
    notice.appendChild(heading);
    notice.appendChild(link.cloneNode(true));
    media.parentNode.insertBefore(notice, media);
  }

  function syncChat() {
    pending = false;
    var chat = document.querySelector('.whatsapp-floating-button');
    if (!chat) return;
    if (!chat.getAttribute('aria-label')) {
      var label = chat.querySelector('.whatsapp-button-text');
      if (label) chat.setAttribute('aria-label', label.textContent.trim());
    }
    chat.setAttribute('role', 'button');
    chat.setAttribute('tabindex', '0');
    if (!chat.hasAttribute('data-m2u-keyboard')) {
      chat.setAttribute('data-m2u-keyboard', 'true');
      chat.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chat.click();
        }
      });
    }
    var overlap = false;
    if (mobile.matches && document.activeElement !== chat) {
      var box = chat.getBoundingClientRect();
      var controls = document.querySelectorAll('#MainContent button, #MainContent input, #MainContent select, #MainContent .t4s-product-price, #MainContent .t4s-product__price, #MainContent .t4s-product__info-wrapper, #MainContent .t4s-product-info, #MainContent .m2u-mobile-availability, #MainContent .m2u-product-recovery a');
      overlap = Array.prototype.some.call(controls, function (control) {
        var rect = control.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.left < box.right + 8 && rect.right > box.left - 8 && rect.top < box.bottom + 8 && rect.bottom > box.top - 8;
      });
      var drawer = document.querySelector('.t4s-drawer[aria-hidden="false"]');
      if (drawer) overlap = true;
    }
    chat.classList.toggle('m2u-chat-clear-controls', overlap);
  }

  function scheduleChat() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(syncChat);
  }

  function start() {
    promoteUnavailableStatus();
    syncChat();
    new MutationObserver(function () {
      promoteUnavailableStatus();
      scheduleChat();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    window.addEventListener('scroll', scheduleChat, { passive: true });
    window.addEventListener('resize', scheduleChat, { passive: true });
    document.addEventListener('focusout', scheduleChat);
  }

  var style = document.createElement('style');
  style.id = 'm2u-mobile-availability-styles';
  style.textContent = [
    '.m2u-mobile-availability{display:none}',
    '@media(max-width:767px){',
    '.m2u-mobile-availability{display:block;margin:0 15px 14px;padding:12px 14px;max-width:calc(100% - 30px);border:1px solid #e2c463;border-radius:8px;background:#fff4d2;color:#11104f}',
    '.m2u-mobile-availability p{margin:0;font-size:14px;font-weight:700;line-height:1.4}',
    '.m2u-mobile-availability a{display:inline-flex;align-items:center;min-height:44px;color:#000066;font-size:13px;font-weight:700;text-decoration:underline;text-underline-offset:3px}',
    '.whatsapp-floating-button{width:48px!important;min-width:48px!important;height:48px!important;min-height:48px!important;padding:10px!important;border-radius:50%!important;gap:0!important;animation:none!important}',
    '.whatsapp-floating-button .whatsapp-button-text{display:none!important}',
    '.whatsapp-floating-button .whatsapp-button-icon{margin:0!important;display:flex;align-items:center;justify-content:center}',
    '.whatsapp-floating-button.m2u-chat-clear-controls{opacity:0!important;visibility:hidden!important;pointer-events:none!important}',
    '.whatsapp-floating-button:focus-visible,.m2u-mobile-availability a:focus-visible{outline:3px solid #080071;outline-offset:3px}',
    '}'
  ].join('');
  document.head.appendChild(style);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

(function () {
  var articlePath = '/blogs/sleep-disorders/timed-release-vs-rapid-release-melatonin';
  var queued = false;

  function addRestockLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('.t4s-product[data-product-options]'), function (card) {
      if (card.getAttribute('data-m2u-restock-enhanced') === 'true') return;
      var raw = card.getAttribute('data-product-options');
      var data;
      try { data = JSON.parse(raw); } catch (error) { return; }
      if (data.available) return;

      var info = card.querySelector('.t4s-product-info__inner') || card.querySelector('.t4s-product-info');
      var titleLink = card.querySelector('.t4s-product-title a');
      if (!info || !titleLink) return;

      var actions = info.querySelector('.m2u-card-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'm2u-card-actions';
        info.appendChild(actions);
      }

      var link = document.createElement('a');
      link.className = 'm2u-restock-link';
      link.href = titleLink.getAttribute('href') || ('/products/' + (data.handle || ''));
      link.textContent = 'Get restock alert';
      link.setAttribute('aria-label', 'Get a restock alert for ' + titleLink.textContent.trim());
      actions.appendChild(link);
      card.setAttribute('data-m2u-restock-enhanced', 'true');
    });
  }

  function addArticleShoppingPath() {
    if (window.location.pathname !== articlePath || document.querySelector('.m2u-article-shop-path')) return;
    var article = document.querySelector('#MainContent article');
    var firstParagraph = article && article.querySelector('p');
    if (!firstParagraph) return;

    var callout = document.createElement('aside');
    callout.className = 'm2u-article-shop-path';
    callout.setAttribute('aria-label', 'Compare available melatonin products');

    var heading = document.createElement('h2');
    heading.textContent = 'Ready to compare available options?';
    callout.appendChild(heading);

    var copy = document.createElement('p');
    copy.textContent = 'Compare labelled strength, release type, bottle size and current availability before choosing.';
    callout.appendChild(copy);

    var actions = document.createElement('div');
    actions.className = 'm2u-article-shop-path__actions';

    var compare = document.createElement('a');
    compare.className = 'm2u-primary-action';
    compare.href = '/collections/melatonin#compare-options';
    compare.textContent = 'Compare formats';
    actions.appendChild(compare);

    var shop = document.createElement('a');
    shop.className = 'm2u-secondary-action';
    shop.href = '/collections/melatonin?filter.v.availability=1';
    shop.textContent = 'Shop in-stock melatonin';
    actions.appendChild(shop);

    callout.appendChild(actions);
    firstParagraph.insertAdjacentElement('afterend', callout);
  }

  function enhance() {
    queued = false;
    addRestockLinks();
    addArticleShoppingPath();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(enhance);
  }

  function start() {
    enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  var style = document.createElement('style');
  style.id = 'm2u-r13-sales-paths';
  style.textContent = [
    '.m2u-restock-link{display:inline-flex;align-items:center;justify-content:center;width:100%;min-height:44px;padding:10px 14px;border:2px solid #080071;border-radius:6px;background:#fff;color:#080071;font-weight:700;text-align:center;text-decoration:none}',
    '.m2u-restock-link:hover{background:#f5f4ff;color:#080071}',
    '.m2u-restock-link:focus-visible{outline:3px solid #f5c842;outline-offset:3px}',
    '.m2u-article-shop-path{margin:24px 0;padding:22px;border:1px solid #d8dceb;border-left:5px solid #f5c842;border-radius:10px;background:#f7fbff;color:#17172f}',
    '.m2u-article-shop-path h2{margin:0 0 8px;color:#080071;font-size:1.35rem}',
    '.m2u-article-shop-path p{margin:0;line-height:1.55}',
    '.m2u-article-shop-path__actions{display:flex;flex-wrap:wrap;gap:12px;margin-top:16px}',
    '@media(max-width:767px){.m2u-article-shop-path{margin:18px 0;padding:18px}.m2u-article-shop-path__actions{flex-direction:column}.m2u-article-shop-path__actions a{width:100%}}'
  ].join('');
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

(function () {
  var queued = false;

  function groupTitleAndReviews() {
    var title = document.querySelector('#MainContent h1.t4s-product__title');
    if (!title || title.closest('.m2u-title-review-group')) return;

    var widget = document.querySelector('#MainContent .jdgm-widget.jdgm-preview-badge');
    var placeholder = document.querySelector('#MainContent a.t4s-product__review[href*="#t4s-tab-review"]');
    if (!widget || !placeholder) return;

    var reviewText = (widget.textContent || '').replace(/\s+/g, ' ').trim();
    var countMatch = reviewText.match(/(\d+)\s*reviews?/i);
    if (!countMatch || Number(countMatch[1]) < 1) return;

    var parent = title.parentNode;
    var group = document.createElement('div');
    group.className = 'm2u-title-review-group';
    parent.insertBefore(group, title);
    group.appendChild(title);

    var reviewBlock = document.createElement('div');
    reviewBlock.className = 'm2u-title-review-block';
    group.appendChild(reviewBlock);

    var rating = document.createElement('a');
    rating.className = 'm2u-title-review-link';
    rating.href = placeholder.getAttribute('href');
    rating.setAttribute('aria-label', reviewText + '. Read verified customer reviews');
    var stars = widget.querySelector('.jdgm-prev-badge__stars');
    if (stars) {
      var starCopy = stars.cloneNode(true);
      starCopy.setAttribute('aria-hidden', 'true');
      rating.appendChild(starCopy);
    }
    var reviewCount = document.createElement('span');
    reviewCount.className = 'm2u-title-review-count';
    reviewCount.textContent = countMatch[1] + (Number(countMatch[1]) === 1 ? ' review' : ' reviews');
    rating.appendChild(reviewCount);
    reviewBlock.appendChild(rating);

    var context = document.createElement('a');
    context.className = 'm2u-review-context';
    context.href = rating.getAttribute('href');
    context.textContent = 'Read verified feedback on delivery, packaging and service';
    reviewBlock.appendChild(context);
    var sourceBlock = widget.closest('.shopify-app-block');
    if (sourceBlock) sourceBlock.classList.add('m2u-review-source-hidden');
    placeholder.remove();
  }

  function markPhotoFrames() {
    Array.prototype.forEach.call(document.querySelectorAll('#m2u-product-results .t4s-product-inner'), function (frame) {
      frame.classList.add('m2u-photo-frame');
    });
    Array.prototype.forEach.call(document.querySelectorAll('#MainContent .t4s-product__media'), function (frame) {
      frame.classList.add('m2u-photo-frame');
    });
  }

  function enhance() {
    queued = false;
    markPhotoFrames();
    groupTitleAndReviews();
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(enhance);
  }

  var style = document.createElement('style');
  style.id = 'm2u-r14-photos-reviews';
  style.textContent = [
    '#m2u-product-results .t4s-product-inner.m2u-photo-frame{border-radius:10px}',
    '#m2u-product-results .t4s-product-img{aspect-ratio:1/1;background:#f5f5f2!important;overflow:hidden}',
    '#m2u-product-results .t4s-product-img img{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important;padding:clamp(8px,4%,20px)!important;box-sizing:border-box!important;background:transparent!important}',
    '#MainContent .t4s-product__media.m2u-photo-frame{background:#f5f5f2!important;border-radius:10px;overflow:hidden}',
    '#MainContent .t4s-product__media.m2u-photo-frame img{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important;padding:clamp(12px,3vw,32px)!important;box-sizing:border-box!important;background:transparent!important}',
    '.m2u-title-review-group{display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin:0 0 14px}',
    '.m2u-title-review-group .t4s-product__title{flex:1;min-width:0;margin:0!important}',
    '.m2u-title-review-block{display:flex;flex-direction:column;align-items:flex-end;flex:0 0 auto;gap:4px;max-width:250px}',
    '.m2u-title-review-link{display:inline-flex!important;align-items:center;min-height:32px;color:#11104f!important;text-decoration:none!important;white-space:nowrap}',
    '.m2u-title-review-count{margin-left:6px;color:#333;font-size:13px}',
    '.m2u-review-source-hidden{display:none!important}',
    '.m2u-review-context{color:#3f4c68;font-size:12px;line-height:1.35;text-align:right;text-decoration:underline;text-underline-offset:3px}',
    '.m2u-title-review-link:focus-visible,.m2u-review-context:focus-visible{outline:3px solid #f5c842;outline-offset:3px}',
    '@media(max-width:767px){.m2u-title-review-group{flex-direction:column;gap:8px}.m2u-title-review-block{align-items:flex-start;max-width:none}.m2u-review-context{text-align:left}#MainContent .t4s-product__media.m2u-photo-frame img{padding:16px!important}}'
  ].join('');
  document.head.appendChild(style);

  function start() {
    enhance();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

